// Host-data caching, per the contract's caching commitment (Appendix A):
//   liveStock / upcomingStock  → 60 seconds
//   renewalPipeline            → 5 minutes
//   pricingAndOffers           → 10 minutes
//   customerFootprint          → request-scoped (no TTL here; component-level)
// One cache instance per provider mount = per organisation.

const TTLS = {
  liveStock: 60_000,
  upcomingStock: 60_000,
  renewalPipeline: 300_000,
  pricingAndOffers: 600_000,
};

export const withHostCache = (hostData) => {
  const cache = new Map();
  const wrap = (name) => async (arg) => {
    const ttl = TTLS[name];
    if (!ttl) return hostData[name](arg);
    const key = name + ":" + JSON.stringify(arg ?? null);
    const hit = cache.get(key);
    if (hit && Date.now() - hit.at < ttl) return hit.value;
    const value = await hostData[name](arg);
    cache.set(key, { at: Date.now(), value });
    return value;
  };
  const out = {};
  for (const k of Object.keys(hostData)) {
    out[k] = typeof hostData[k] === "function" ? wrap(k) : hostData[k];
  }
  return out;
};
